import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { CheckCircle2, XCircle, Loader2, PawPrint } from "lucide-react";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const intentId = params.get("intent_id");
  const success = params.get("success") === "1";
  const [intent, setIntent] = useState(null);
  const [polling, setPolling] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!intentId) { setPolling(false); return; }
    let cancelled = false;
    let attempts = 0;
    const tick = async () => {
      attempts += 1;
      try {
        const r = await axios.get(`${API}/payments/intent/${intentId}`);
        if (cancelled) return;
        setIntent(r.data);
        if (r.data.status !== "created" || attempts >= 8) { setPolling(false); return; }
        setTimeout(tick, 1500);
      } catch (e) {
        setPolling(false);
      }
    };
    tick();
    return () => { cancelled = true; };
  }, [intentId]);

  const ok = intent?.status === "succeeded" || (success && intent?.status === "created");

  return (
    <div className="min-h-screen bg-bg grid place-items-center p-6" data-testid="payment-return-page">
      <div className="bg-surface border border-line rounded-3xl shadow-soft max-w-md w-full p-8 text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <div className="w-9 h-9 rounded-2xl bg-brand grid place-items-center"><PawPrint className="w-4 h-4 text-white"/></div>
          <span className="font-heading text-xl font-extrabold">Pet<span className="text-brand">Bond</span></span>
        </div>
        {polling && (
          <>
            <Loader2 className="w-12 h-12 text-brand animate-spin mx-auto mb-3"/>
            <div className="font-heading text-xl font-extrabold">Confirming your payment…</div>
            <p className="text-ink-soft text-sm mt-1">This usually takes 1-2 seconds.</p>
          </>
        )}
        {!polling && ok && (
          <>
            <CheckCircle2 className="w-14 h-14 text-leaf mx-auto mb-3"/>
            <div className="font-heading text-2xl font-extrabold">Payment successful!</div>
            <p className="text-ink-soft mt-1">
              {intent?.currency === "INR" ? "₹" : "$"}{Math.round((intent?.amount || 0) / 100)} · {intent?.purpose}
            </p>
            <button data-testid="return-to-app" onClick={() => navigate("/app")} className="mt-5 bg-brand text-white rounded-full px-6 py-3 font-bold hover:bg-brand-hover">Back to PetBond</button>
          </>
        )}
        {!polling && !ok && (
          <>
            <XCircle className="w-14 h-14 text-danger mx-auto mb-3"/>
            <div className="font-heading text-2xl font-extrabold">Payment didn't complete</div>
            <p className="text-ink-soft mt-1">{success ? "We couldn't confirm with the gateway. Please try again." : "You cancelled the checkout."}</p>
            <Link to="/app" className="mt-5 inline-block bg-ink text-white rounded-full px-6 py-3 font-bold">Back to PetBond</Link>
          </>
        )}
      </div>
    </div>
  );
}
